import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./css/Testimonials.css";
import axios from "axios";
import { Testimonials_BASE_URL } from "../../configs/WebServiceUrl";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import userStore from "../../zustand/userStore";

const EmojiInput = ({ field, form, setForm }) => {
  const [showEmojis, setShowEmojis] = useState(false);

  const emojis = [
    // "👶",
    // "👶🏻",
    // "👶🏼",
    // "👶🏽",
    // "👶🏾",
    // "👶🏿",
    "🧒",
    "🧒🏻",
    "🧒🏼",
    "🧒🏽",
    "🧒🏾",
    "🧒🏿",
    "👦",
    "👦🏻",
    "👦🏼",
    "👦🏽",
    "👦🏾",
    "👦🏿",
    "👧",
    "👧🏻",
    "👧🏼",
    "👧🏽",
    "👧🏾",
    "👧🏿",

    "🧑",
    "🧑🏻",
    "🧑🏼",
    "🧑🏽",
    "🧑🏾",
    "🧑🏿",
    "👩",
    "👩🏻",
    "👩🏼",
    "👩🏽",
    "👩🏾",
    "👩🏿",
    "👨",
    "👨🏻",
    "👨🏼",
    "👨🏽",
    "👨🏾",
    "👨🏿",

    "🧓",
    "🧓🏻",
    "🧓🏼",
    "🧓🏽",
    "🧓🏾",
    "🧓🏿",
    "👵",
    "👵🏻",
    "👵🏼",
    "👵🏽",
    "👵🏾",
    "👵🏿",
    "👴",
    "👴🏻",
    "👴🏼",
    "👴🏽",
    "👴🏾",
    "👴🏿",

    "👳",
    "👳🏻",
    "👳🏼",
    "👳🏽",
    "👳🏾",
    "👳🏿",
    "👩‍🧕",
    "👳‍♀️",
    "👳‍♂️",
    "👮",
    "👮🏻",
    "👮🏼",
    "👮🏽",
    "👮🏾",
    "👮🏿",

    "👷",
    "👷🏻",
    "👷🏼",
    "👷🏽",
    "👷🏾",
    "👷🏿",
    "💂",
    "💂🏻",
    "💂🏼",
    "💂🏽",
    "💂🏾",
    "💂🏿",

    "🕵️",
    "🕵🏻",
    "🕵🏼",
    "🕵🏽",
    "🕵🏾",
    "🕵🏿",
    "👩‍⚕️",
    "👨‍⚕️",
    "👩‍🏫",
    "👨‍🏫",
    "👩‍💻",
    "👨‍💻",
    "👩‍🔧",
    "👨‍🔧",

    "👩‍🍳",
    "👨‍🍳",
    "👩‍🎓",
    "👨‍🎓",
    "👩‍🎤",
    "👨‍🎤",
    "👩‍⚖️",
    "👨‍⚖️",

    "🧑‍🎄",
    "👩‍🎄",
    "👨‍🎄",
    "🧑‍🚀",
    "👩‍🚀",
    "👨‍🚀",
    "🧑‍✈️",
    "👩‍✈️",
    "👨‍✈️",
  ];

  return (
    <div
      style={{ position: "relative", width: "100%" }}
      onMouseEnter={() => setShowEmojis(true)}
      onMouseLeave={() => setShowEmojis(true)}
    >
      <input
        type={field.type || "text"}
        className="form-control"
        value={form[field.key] || ""}
        onChange={(e) => setForm({ ...form, [field.key]: e.target.value })}
        style={{ width: "100%" }}
      />

      {showEmojis && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "6px",
            background: "#fff",
            padding: "6px 10px",
            borderRadius: "8px",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.2)",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "6px",
            zIndex: 1000,
            height: "10vh",
            overflow: "auto",
          }}
        >
          {emojis.map((emoji, index) => (
            <span
              key={index}
              style={{
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={() =>
                setForm({
                  ...form,
                  [field.key]: (form[field.key] || "") + emoji,
                })
              }
            >
              {emoji}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
const stats = [
  { value: "10,000+", label: "Happy Students" },
  { value: "500+", label: "Registered Schools" },
  { value: "₹50,000+", label: "Prizes Distributed" },
  { value: "1,000+", label: "Success Stories" },
];

const featureBoxes = [
  {
    title: "Quiz Champions",
    desc: "Students who have excelled in competitive quizzes and won significant prizes",
    icon: "🏆",
    bg: "linear-gradient(90deg,#f3f6ff,#eef7ff)",
  },
  {
    title: "Academic Excellence",
    desc: "Students showing remarkable improvement in their academic performance",
    icon: "🎓",
    bg: "linear-gradient(90deg,#eefaf2,#f5fff6)",
  },
  {
    title: "School Success",
    desc: "Educational institutions achieving outstanding results with our platform",
    icon: "🏫",
    bg: "linear-gradient(90deg,#fff6f0,#fff6f0)",
  },
];

const Testimonials = () => {
  const userData = userStore((state) => state.user);
  const TestimonialsList = `${Testimonials_BASE_URL}/api/school/syllabus/testmonials/published`;
  const [testimonialItems, setTestimonials] = useState([]);
  const [form, setForm] = useState({
    name: "",
    role: "",
    org: "",
    rating: "",
    quote: "",
    tag: "",
    avatar: "",
    mode: "",
    id: "",
    showPopUp: false,
    testimonialsList: [],
  });

  useEffect(() => {
    axios
      // .get(`${BASE_URL}/homepage/testimonials`)
      .get(TestimonialsList)
      .then((res) => setTestimonials(res.data?.data || []))
      .catch((err) => console.error("Error fetching testimonials:", err));
  }, []);
  const resetPopup = () => {
    setForm((prev) => ({ ...prev, showPopUp: false, mode: "" }));
  };
  return (
    <div className="testimonials-page">
      <header className="tm-header bg-light py-5">
        <div className="tm-container text-center">
          <div className="header-title">
            <h1>Student Testimonials</h1>
            <p>
              Hear from our amazing students, teachers, and schools about their
              DocMaster Quiz experience
            </p>
          </div>

          <div className="stats-row">
            {stats.map((s, idx) => (
              <div key={idx} className="stat-item">
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </header>
      <button
        title="Add new testimonial"
        style={{
          float: "right",
          backgroundColor: "#0d6efd",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          padding: "8px 18px",
          fontSize: "14px",
          fontWeight: "500",
          cursor: "pointer",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.15)",
          marginTop: "1%",
        }}
        onClick={() =>
          setForm((prev) => ({
            ...prev,
            showPopUp: true,
            name: userData?.admin_name || "",
            role: userData?.role || "",
            org: userData?.school_name || "",
          }))
        }
      >
        + Add
      </button>
      <main className="tm-container tm-main">
        <section className="testimonials-grid">
          {testimonialItems?.length > 0 &&
            testimonialItems?.map((t, i) => (
              <article key={i} className="testimonial-card">
                <div className="tc-top">
                  <div className="tc-avatar">{t.avatar}</div>
                  <div className="tc-person">
                    <div className="tc-name">{t.name}</div>
                    <div className="tc-sub">{t.role}</div>
                    <div className="tc-org">{t.org}</div>
                  </div>
                  <div className="tc-rating">
                    {Array.from({ length: t.rating }).map((_, r) => (
                      <span key={r} className="star">
                        ★
                      </span>
                    ))}
                  </div>
                </div>

                <div className="tc-quote">"{t.quote}"</div>

                <div className="tc-badge">{t.tag}</div>
              </article>
            ))}
        </section>

        <section className="features-row">
          {featureBoxes.map((f, idx) => (
            <div className="feature-box" key={idx} style={{ background: f.bg }}>
              <div className="feature-icon">{f.icon}</div>
              <h4 className="feature-title">{f.title}</h4>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </section>

        <section className="cta-box">
          <h3>Join Our Success Community</h3>
          <p>
            Be part of thousands of students achieving academic excellence
            through interactive learning
          </p>
          <div className="cta-actions">
            <button className="btn-primary large">Start Your Journey</button>
            <button className="btn-outline large">View Success Stories</button>
          </div>
        </section>
      </main>
      <Dialog
        fullWidth
        maxWidth="lg"
        // style={{ height: "99vh" }}
        onClose={() =>
          setForm((prev) => ({
            ...prev,
            showPopUp: false,
          }))
        }
        open={form.showPopUp}
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>
            {" "}
            <strong> Add New Testinomial</strong>
          </span>
          <i
            className="bi bi-x"
            style={{ float: "right", cursor: "pointer" }}
            onClick={resetPopup}
          />
        </DialogTitle>

        <DialogContent>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 20,
            }}
          >
            {[
              { key: "name", label: "Name" },
              { key: "role", label: "Designation / Role" },
              { key: "org", label: "School Name" },
              { key: "tag", label: "Achievement / Position Secured" },
              { key: "rating", label: "Rating", type: "number" },
              { key: "avatar", label: "Avatar Emoji", emoji: true },
              { key: "quote", label: "Content (Quote)", textarea: true },
            ].map((field) => (
              <div key={field.key}>
                <label>{field.label}</label>
                {field.textarea ? (
                  <textarea
                    rows={3}
                    className="form-control"
                    value={form[field.key]}
                    onChange={(e) =>
                      setForm({ ...form, [field.key]: e.target.value })
                    }
                  />
                ) : field.emoji ? (
                  <EmojiInput field={field} form={form} setForm={setForm} />
                ) : (
                  <input
                    type={field.type || "text"}
                    className="form-control"
                    value={form[field.key]}
                    onChange={(e) =>
                      setForm({ ...form, [field.key]: e.target.value })
                    }
                    disabled={
                      ["name", "role", "org"].includes(field.key) &&
                      !!form[field.key]
                    }
                  />
                )}
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Testimonials;
